const KEY = 'clash-of-stamp-telemetry-v1';

export class Telemetry {
  constructor(enabled = false) {
    this.enabled = Boolean(enabled);
    this.sessionId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
  }

  setEnabled(enabled) {
    this.enabled = Boolean(enabled);
    if (!this.enabled) localStorage.removeItem(KEY);
  }

  track(name, properties = {}) {
    if (!this.enabled) return;
    const safe = Object.fromEntries(Object.entries(properties).filter(([, value]) => ['string', 'number', 'boolean'].includes(typeof value)).slice(0, 12));
    let events = [];
    try { events = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { events = []; }
    events.push({ name: String(name).slice(0, 48), properties: safe, at: Date.now(), sessionId: this.sessionId });
    localStorage.setItem(KEY, JSON.stringify(events.slice(-60)));
  }

  captureError(error, context = '') {
    this.track('client_error', { context: String(context).slice(0, 80), message: String(error?.message || error).slice(0, 160) });
  }

  summary() {
    if (!this.enabled) return { enabled: false, count: 0 };
    try { return { enabled: true, count: JSON.parse(localStorage.getItem(KEY) || '[]').length }; }
    catch { return { enabled: true, count: 0 }; }
  }
}
